<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>Again to Carol</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?852d53e4